// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"1290":"social-widget","5802":"expanded-widget","6098":"chat-interactivity"}[chunkId] + ".chunk.min.css";
};